import { Administrateur } from './administrateur';

export class Adminstorage {
    administrateur: Administrateur;
    token: string;

}
